import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ProfileCard from '../../../components/ProfileCard/ProfileCard'
import Profiledetails from './Profiledetails';
import Settings from './Settings';
import { useDispatch, useSelector } from 'react-redux';
import { adminData, changePassword, clearState, getOrgDetails, getParticularUser, updateOrgDetails, updateUserDetails } from '../../../reducer/adminSlice';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import ErrorToast from '../../../components/Toast/ErrorToast';
import SuccessToast from '../../../components/Toast/SuccessToast';
import * as filestack from 'filestack-js';

function AdMyProfile() {

    //Edit profile Templates
    const template = {
        profileImg: "",
        firstName: "",
        lastName: "",
        designation: "",
        company: "",
        mobileNumber: "",
        email: "",
        linkedin: ""
    };

    //Manage Org Templates
    const manageOrgTemplate = {
        name: "",
        logoUrl: "",
        primaryColorTheme: "#3397EF"
    };

    const errorOrgTemplate = {
        name: "",
        logoUrl: "",
        primaryColorTheme: "#"
    }

    //Change pass templates
    const changePassTemplate = {
        password: "",
        newPassword: "",
        confirmPassword: "",
    }

    const [TabSlotProfile, setTabSlotProfile] = useState(1);


    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");
    const [isShowSuccess, setIsShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    //Edit profile States
    const [isLoading, setIsLoading] = useState(false);
    const [admin, setAdmin] = useState(template);

    //Manage Org States
    const [orgDetails, setOrgDetails] = useState(manageOrgTemplate);
    const [errorOrgDetails, setErrorOrgDetails] = useState(errorOrgTemplate);

    //ChangePassword States
    const [changePassToggler, setChangePassToggler] = useState(1);
    const [password, setPassword] = useState(changePassTemplate);
    const [errorPassword, setErrorPassword] = useState(changePassTemplate);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isFetching, isSuccess, isError, errorMessage, particularUser, organizationDetails } = useSelector(adminData);

    //Edit profile functions
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "mobileNumber" && (value?.length > 10 || value < 0)) return;
        setAdmin(prev => ({
            ...prev,
            [name]: value
        }))
    };

    const handleOrgChange = (e) => {
        const { name, value } = e.target;
        setOrgDetails(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handleUploadProfile = (e) => {
        const client = filestack.init("AASYllbvHQ3u0A1GxbOvZz");

        client.picker({
            accept: ['image/*'],
            onUploadDone: (result) => {
                if (result?.filesFailed?.length > 0) {
                    setIsShowError(true);
                    setErrMessage("Something went wrong")
                }
                if (result?.filesUploaded?.length > 0) {
                    setAdmin(prev => ({
                        ...prev,
                        profileImg: result?.filesUploaded[0]?.url
                    }));
                }
            },
        }).open();
    };

    const handleDiscard = () => {
        setAdmin({
            profileImg: particularUser?.profileImg ?? "",
            firstName: particularUser?.firstName ?? "",
            lastName: particularUser?.lastName ?? "",
            designation: particularUser?.profession?.designation ?? "",
            company: particularUser?.profession?.company ?? "",
            mobileNumber: particularUser?.mobileNumber ?? "",
            email: particularUser?.email ?? "",
            linkedin: particularUser?.linkedin ?? ""
        });
    };

    const handleSave = () => {
        setTabSlotProfile(1);
        dispatch(updateUserDetails(admin));
    };

    //Manage org functions
    const handleUploadLogo = (e) => {
        if (e.target.files.length > 0) {
            const files = e.target.files[0];
            setIsLoading(true);
            const data = new FormData();

            data.append("file", files);
            data.append("upload_preset", "qlm4yp8h");
            data.append("cloud_name", "df491ehfg");

            fetch("https://api.cloudinary.com/v1_1/df491ehfg/raw/upload", {
                method: "POST",
                body: data,
            })
                .then((res) => res.json())
                .then((res) => {


                    setIsLoading(false);
                    setOrgDetails(prev => ({
                        ...prev,
                        logoUrl: res.secure_url
                    }));
                })
                .catch((err) => {
                    console.log(err);
                    setIsLoading(false);
                });
        }
    };

    //Change Password Functions
    const handleShowChangePass = () => {
        setChangePassToggler(2);
    };

    const handleCancelChangePass = () => {
        setPassword(changePassTemplate);
        setErrorPassword(changePassTemplate);
        setChangePassToggler(1);
    }

    const handlePassChange = (e) => {
        setErrorPassword(changePassTemplate);
        const { name, value } = e.target;
        setPassword(prev => ({
            ...prev,
            [name]: value
        }))
    };

    const validatePassword = () => {
        for (const key in password) {
            if (!password[key]) {
                setErrorPassword(prev => ({
                    ...prev,
                    [key]: "Please fill this field"
                }));
                return true;
            }
        }
        if (password["confirmPassword"] !== password["newPassword"]) {
            setErrorPassword(prev => ({
                ...prev,
                confirmPassword: "Password do not match!"
            }));
            return true;
        }
        if (password["newPassword"].length < 6) {
            setErrorPassword(prev => ({
                ...prev,
                newPassword: "Password should be atleast 6 digit long!"
            }));
            return true;
        }
        return false;
    };

    const handlePassChangeConfirm = () => {
        if (!validatePassword()) {
            dispatch(changePassword(password));
        }
    };

    const handlePassPressConfirm = (e) => {
        if (e.key === "Enter") {
            if (!validatePassword()) {
                dispatch(changePassword(password));
            }
        }
    };

    //Manage Org functions
    const handleOrgDetailsDiscard = () => {
        setOrgDetails(prev => ({
            ...prev,
            name: organizationDetails?.name,
            logoUrl: organizationDetails?.logoUrl,
            primaryColorTheme: organizationDetails?.primaryColorTheme,
        }));
    };

    const validateOrgDetails = () => {
        for (const key in orgDetails) {
            if (!orgDetails[key]) {
                setErrorOrgDetails(prev => ({
                    ...prev,
                    [key]: "This field cannot be empty!"
                }))
                return true;
            }
        }
        return false;
    }

    const handleOrgDetailsSave = () => {
        if (!validateOrgDetails()) {
            dispatch(updateOrgDetails(orgDetails));
        }
    }

    useEffect(() => {
        if (TabSlotProfile === 1) dispatch(getParticularUser({ user: "admin", userId: localStorage.getItem("userId") }));
        if (TabSlotProfile === 3) dispatch(getOrgDetails());
    }, [TabSlotProfile]);

    useEffect(() => {
        setAdmin({
            profileImg: particularUser?.profileImg ?? "",
            firstName: particularUser?.firstName ?? "",
            lastName: particularUser?.lastName ?? "",
            designation: particularUser?.profession?.designation ?? "",
            company: particularUser?.profession?.company ?? "",
            mobileNumber: particularUser?.mobileNumber ?? "",
            email: particularUser?.email ?? "",
            linkedin: particularUser?.linkedin ?? ""
        });
    }, [particularUser]);

    useEffect(() => {
        if (organizationDetails) {
            setOrgDetails(prev => ({
                ...prev,
                name: organizationDetails?.name,
                logoUrl: organizationDetails?.logoUrl,
                primaryColorTheme: organizationDetails?.primaryColorTheme,
            }))
        }
    }, [organizationDetails])

    useEffect(() => {
        if (isSuccess) {
            setPassword(changePassTemplate);
            setErrorPassword(changePassTemplate);
            setIsShowSuccess(true);
            setSuccessMessage("Success");
            setChangePassToggler(1);
            setTabSlotProfile(1);
            dispatch(getParticularUser({ user: "admin", userId: localStorage.getItem("userId") }))
            dispatch(clearState());
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError) {
            setIsShowError(true);
            setErrMessage(errorMessage);
            dispatch(clearState());
        }
    }, [isError]);

    return (
        <>
            {(isLoading || isFetching) && <PageLoader />}
            <ErrorToast
                show={isShowError}
                setShow={() => setIsShowError(false)}
                message={errMessage}
            />
            <SuccessToast
                show={isShowSuccess}
                setShow={() => setIsShowSuccess(false)}
                message={successMessage}
            />
            <section className=''>
                <div className="DashboardWrapper">
                    <div className="headingprofilewrap">
                        <h2 className='heading-2'>My Profile</h2>
                    </div>

                    <div className="flex-col Allcardboxwrapper mt-30">
                        <div className="profilewrapper w-100 ">
                            <div className="Adprofiledatawrapper flex-start">
                                <div className='Imageboxall'>
                                    <img src={particularUser?.profileImg ? particularUser?.profileImg : "/assets/img/user2.jpeg"} alt="" />
                                </div>
                                <div className="AdProfileDetailsarea">
                                    <div className="headingwrap">
                                        <div className="headingorg flex gap-10">
                                            <h2 className='heading-2'>{particularUser?.firstName ? `${particularUser?.firstName} ${particularUser?.lastName}` : "---"}</h2>
                                            {particularUser?.linkedin && <a target='_blank' href={particularUser?.linkedin.slice(0, 4) === "http" ? particularUser?.linkedin : "https://" + particularUser?.linkedin} className='linkedintext' rel='noreferrer'>
                                                <span className='flex gap-2'>
                                                    Linkedin
                                                    <img src="/assets/img/send.png" alt="" />
                                                </span>
                                            </a>}
                                        </div>
                                        <div className="AdPsnlDetailsMentors mt-10">
                                            <div className="AdMentorSubDetails f-items-center">
                                                <span className="flex-center">
                                                    <img src="/assets/img/contact/usermentor.png" alt="" />
                                                </span>
                                                <p className="text2">Admin</p>
                                            </div>
                                            <div className="AdMentorSubDetails f-items-center">
                                                <span className="flex-center">
                                                    <img src="/assets/img/contact/emailprofile.png" alt="" />
                                                </span>
                                                <p className="text2">{particularUser?.email ? particularUser?.email : "---"}</p>
                                            </div>
                                            <div className="AdMentorSubDetails f-items-center">
                                                <span className="flex-center">
                                                    <img src="/assets/img/contact/callprofile.png" alt="" />
                                                </span>
                                                <p className="text2">{particularUser?.mobileNumber ? particularUser?.mobileNumber : "---"}</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="AdMenusTabWrapper w-100 mt-40">
                            <ul className='flex gap-30 items-center'>

                                <li onClick={() => setTabSlotProfile(1)} className={TabSlotProfile === 1 && 'active'}>Profile Details</li>
                                <li onClick={() => setTabSlotProfile(2)} className={TabSlotProfile === 2 && 'active'}>Settings</li>
                            </ul>
                        </div>

                    </div>

                </div>

                <Profiledetails isActiveTab={TabSlotProfile === 1 && 'active'} data={particularUser} editProfile={() => setTabSlotProfile(2)} />
                <Settings isActiveTab={TabSlotProfile === 2 && 'active'} changePassToggler={changePassToggler} data={admin} password={password} errorPassword={errorPassword} handleDiscard={handleDiscard} handleSave={handleSave} handleChange={handleChange} handleUploadProfile={handleUploadProfile} handlePassChange={handlePassChange} handleShowChangePass={handleShowChangePass} handleCancelChangePass={handleCancelChangePass} handlePassChangeConfirm={handlePassChangeConfirm} handlePassPressConfirm={handlePassPressConfirm} />

            </section>
        </>
    )
}

export default AdMyProfile